import React from 'react'
import '../CSS/ReviewBooking.css'
import Input from "@material-tailwind/react/Input";
import Button from "@material-tailwind/react/Button";
import { Link } from 'react-router-dom'
import { useStateValue } from '../StateProvider';
import NavOnlyIcons from './NavOnlyIcons';

const ReviewBooking = () => {

    const [{date,time,mode}] = useStateValue();

    return (
        <div className="ReviewBooking">
            <div className="navDiv">
                <NavOnlyIcons />
            </div>
            
            <div className="ReviewBookingSubDiv">
                 <div className="stepsDone">
                        <Link to='/AppointmentPage'>
                            <div className="stepOne" >       
                                <Button >1 Select Mode</Button>
                            </div>
                        </Link>

                        <Link to='/calendar'>
                            <div className="stepTwo" >
                                <Button>2 Date & Time</Button>
                            </div>
                        </Link>

                        <div className="stepThree">
                            <Button id='selectMode3'>3 Review data</Button>
                        </div>
                </div>
                <h1>REVIEW YOUR BOOKING</h1>
                <h2><Link to="/AppointmentPage"><i className="fas fa-chevron-left"></i>Back to Appointment</Link></h2>

                <div className="ReviewBookingSubMain">
                    <div className="reviewDivLeft">
                        <h1>Your Appointment Details</h1>
                        <h4>Expert : <small>To Be Assigned</small></h4> 
                        <h4>Date : <small>{date} 2021</small></h4> 
                        <h4>Time : <small>{time} </small></h4> 
                        <h4>Type : <small>{mode}</small></h4> 
                        <h4>Charges : <small>Rs. 1,299</small></h4> 

                        <div className="reviewDivLeftFooter">
                            <Input type="text"color="lightBlue"size="regular" outline={false} placeholder="Coupon"/>
                            <Button color="lightBlue"buttonType="filled" size="regular" iconOnly={false} ripple="light">
                                Apply

                            </Button>
                        </div>
                       
                    </div>

                    <div className="reviewDivRight">
                        <h1>Please provide us with your contact details</h1>
                        <p>So we may keep you updated about your appointment's status.</p>
                        <br/>
                        <Input type="text"color="lightBlue"size="regular" outline={false} placeholder="Phone Number"/>
                        <div className="interNatNumber">
                            <input type="checkbox" name="" id="" />
                            <small>Please select incase of International Number</small>
                        </div>
                        <br/>
                        <Input type="text" color="lightBlue" size="regular" outline={false} placeholder="Email"/>
                        <small>Important communications will be sent here</small>

                        <Button color="lightBlue"buttonType="filled" size="regular" iconOnly={false} ripple="light">
                            Continue to Payment
                        </Button>
                    </div>
                </div>
            </div> 
        </div>
    )
}

export default ReviewBooking
